import styled from 'styled-components';
import { device } from 'theme';

export const ArticleContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: #000;
  min-height: 100vh;
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 16px;
  padding: 10px 0;
  margin-bottom: 20px;

  &:hover {
    color: #fff;
  }
`;

export const ArticleHeader = styled.div`
  margin-bottom: 30px;
  border-bottom: 1px solid ${(props) => props.$borderColor || '#fff'};
  padding-bottom: 20px;
`;

export const ArticleTitle = styled.h1`
  font-size: 32px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 10px 0;
  line-height: 1.3;
`;

export const ModalArticleTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 10px 0;
  line-height: 1.3;
`;

export const ArticleDate = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
`;

export const GameLink = styled.a`
  font-size: 14px;
  color: ${(props) => props.$color || '#fff'};
  margin: 10px 0 0 0;
  display: block;
  text-decoration: underline;
  cursor: pointer;
  line-height: 1.6;

  &:hover {
    opacity: 0.8;
  }
`;

export const ArticleContent = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #ddd;

  p {
    margin-bottom: 1em;
  }

  h1 {
    font-size: 20px;
    margin-top: 25px;
    margin-bottom: 12px;
    color: #fff;
    font-weight: bold;
  }

  h2 {
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #fff;
    font-weight: bold;
  }

  h3 {
    font-size: 16px;
    margin-top: 18px;
    margin-bottom: 8px;
    color: #fff;
    font-weight: bold;
  }

  h4,
  h5,
  h6 {
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 8px;
    color: #fff;
    font-weight: bold;
  }

  strong,
  b {
    font-weight: bold;
    color: #fff;
  }

  em,
  i {
    font-style: italic;
  }

  img {
    max-width: 100%;
    height: auto;
    margin: 20px 0;
  }

  a {
    color: #6b8afd;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: #8ba4ff;
    }
  }

  ul,
  ol {
    margin: 1em 0;
    padding-left: 30px;
  }

  li {
    margin-bottom: 0.5em;
  }

  blockquote {
    border-left: 4px solid #444;
    padding-left: 20px;
    margin: 20px 0;
    font-style: italic;
    color: #999;
  }

  code {
    background: #1a1a1a;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: monospace;
    font-size: 13px;
    color: #e06c75;
  }

  pre {
    background: #1a1a1a;
    padding: 15px;
    border-radius: 5px;
    overflow-x: auto;
    margin: 1em 0;

    code {
      background: none;
      padding: 0;
      color: #ddd;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1.5em 0;
    background: #1a1a1a;
    border-radius: 5px;
    overflow: hidden;
  }

  thead {
    background: #2a2a2a;
  }

  th {
    padding: 12px;
    text-align: left;
    font-weight: bold;
    color: #fff;
    border-bottom: 2px solid #444;
  }

  td {
    padding: 10px 12px;
    border-bottom: 1px solid #333;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: #252525;
  }
`;

export const ErrorMessage = styled.div`
  color: ${(props) => props.$mainColor || '#ff6b6b'};
  font-size: 0.9rem;
  text-align: center;
  padding: 20px;

  @media ${device.tablet} {
    font-size: 1.1rem;
  }
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 5px;
  left: 20px;
  right: 20px;
  display: flex;
  justify-content: center;
  padding: 4px 0;
`;

export const ViewAsWebpageButton = styled.button`
  background: transparent;
  border: none;
  color: ${(props) => props.$color || '#fff'};
  cursor: pointer;
  font-size: 14px;
  padding: 4px 8px;
  text-decoration: underline;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.5;
  }
`;
